import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserRolesService } from 'src/app/shared/services/user-roles.service';

export function hasRole(role: string): CanActivateFn {
  return (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
    const userRolesService: UserRolesService = inject(UserRolesService);
    const router: Router = inject(Router);

    return userRolesService.isUserInRole(role).pipe(
      switchMap((hasRole) => {
        if (!hasRole) {
          router.navigate(['access-restricted']);
          return of(false);
        }
        return of(true);
      })
    );
  };
}
